import React from "react";
import TextInput from "../../form/TextInput";

export default class BankAccountForm extends React.Component {
    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-4 col-sm-push-8">
                        <TextInput name={this.props.componentConfig.idfield} value={this.props.values[this.props.componentConfig.idfield]} label="Kód"
                                   role="idfield" {...this.props.getFieldProps(this.props.componentConfig.idfield)}/>
                    </div>
                    <div className="col-sm-8 col-sm-pull-4">
                        <TextInput name="name" value={this.props.values.name} label="Név" {...this.props.getFieldProps("name")} saveChanges={this.props.setFieldValue} disabled={true}/>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <TextInput name="bank" value={this.props.values.bank} label="Bank" {...this.props.getFieldProps("bank")} saveChanges={this.props.setFieldValue}/>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-6">
                        <TextInput name="account_name" value={this.props.values.account_name} label="Számla név" {...this.props.getFieldProps("account_name")} saveChanges={this.props.setFieldValue}/>
                    </div>
                    <div className="col-md-6">
                        <TextInput name="account_num" value={this.props.values.account_num} label="Számlaszám" {...this.props.getFieldProps("account_num")} saveChanges={this.props.setFieldValue}/>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-6">
                        <TextInput name="iban" value={this.props.values.iban} label="Iban" {...this.props.getFieldProps("iban")} saveChanges={this.props.setFieldValue}/>
                    </div>
                    <div className="col-md-6">
                        <TextInput name="swift" value={this.props.values.swift} label="Swift" {...this.props.getFieldProps("swift")} saveChanges={this.props.setFieldValue}/>
                    </div>
                </div>
            </form>
        );
    }
}